import React from 'react'
import { Col, InputNumber, Row, Slider } from 'antd'
import 'antd/lib/slider/style/index.css'
import 'antd/lib/tooltip/style/index.css'
import 'antd/lib/input-number/style/index.css'

interface InputSliderProps {
  onChange: (mhs: number) => void
  max: number
  defaultValue: number
}

export default class InputSlider extends React.Component<InputSliderProps> {
  state = {
    inputValue: this.props.defaultValue,
  }

  componentDidMount() {
    this.onChange(this.state.inputValue)
  }

  onChange = (val) => {
    let value = Number(val)
    if (value > this.props.max) value = this.props.max

    this.setState({
      inputValue: value,
    })
    this.props.onChange(value)
  }

  render() {
    const props = {
      max: this.props.max,
      min: 1,
      onChange: this.onChange,
      value: this.state.inputValue,
    }

    return (
      <Row>
        <Col span={22}>
          <Slider {...props}/>
        </Col>
        <Col span={2}>
          <InputNumber
            {...props}
            style={{ marginLeft: 16 }}
            size="small"
          />
        </Col>
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/InputSlider/index.tsx